import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CreateTest from './pages/CreateTest';
import TestDetails from './pages/TestDetails';
import TestSubmissions from './pages/TestSubmissions';
import SubmissionDetails from './pages/SubmissionDetails';
import StudentAccess from './pages/StudentAccess';
import TakeTest from './pages/TakeTest';
import TestSubmitted from './pages/TestSubmitted';

// Protected Route Component
function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return <div style={styles.loading}>Lädt...</div>;
    }

    return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
    return (
        <Router>
            <AuthProvider>
                <div className="App">
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/student" element={<StudentAccess />} />
                        <Route path="/take-test" element={<TakeTest />} />
                        <Route path="/test-submitted" element={<TestSubmitted />} />

                        {/* Protected Routes */}
                        <Route 
                            path="/dashboard" 
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/create-test" 
                            element={
                                <ProtectedRoute>
                                    <CreateTest />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/test/:id" 
                            element={
                                <ProtectedRoute>
                                    <TestDetails />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/test/:id/submissions" 
                            element={
                                <ProtectedRoute>
                                    <TestSubmissions />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/test/:testId/submissions/:submissionId" 
                            element={
                                <ProtectedRoute>
                                    <SubmissionDetails />
                                </ProtectedRoute>
                            } 
                        />

                        {/* Default Route */}
                        <Route path="/" element={<Navigate to="/login" />} />
                        <Route path="*" element={<Navigate to="/login" />} />
                    </Routes>
                </div>
            </AuthProvider>
        </Router>
    );
}

const styles = {
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontSize: '1.5rem',
        color: '#666',
    },
};

export default App;
